import { Catch, Recapture, Filter, ICESFilter, ICESCatchGroup } from '../../models';
import { FormatterHelper } from '../common/formatter.helper';

export class CatchesHelper {

    catches: Catch[];
    formatter: FormatterHelper;

    constructor() {
        this.catches = [];
        this.formatter = new FormatterHelper();
    }

    createCatch(data: any): Catch {
        return {            
            ICES : data.ices_rectangle ? data.ices_rectangle : '?',
            CatchYear : data.catchdate,
            FactoryId : data.reference_plant,
            FactoryName : data.plant_name,
            FactoryICES : data.plant_ices_rectangle,
            Catches: data.catches,
            TotalWeight: data.TotalWeight
        }
    }

    public findCatches(filter: Filter): Catch[] {
        return this.catches.filter(c => 
            ((filter.Year == 0 || c.CatchYear === filter.Year) && (filter.Factory.length == 0 || filter.Factory.includes(c.FactoryId))));
    }

    public findCatchesByICES(filter: ICESFilter): Catch[] {
        return this.catches.filter(c => 
            ((filter.Year == 0 || c.CatchYear === filter.Year) && c.ICES === filter.ICES));
    }
    
    public getMinCatchGroup(groups: ICESCatchGroup[]): ICESCatchGroup {
        return this.formatter.getMinGroup(groups);
    }

    public getMaxCatchGroup(groups: ICESCatchGroup []): ICESCatchGroup {
        return this.formatter.getMaxGroup(groups);
    }
    
    public groupByICES(catches: Catch[]): ICESCatchGroup[]  {
        let groups = [];
        let result = catches.reduce((r, a) => this.group(r, a), Object.create(null));
        // Make a list of groups
        if (result) {
            for (let key in result) {
                if (key != '?') {
                    result[key].Total = Math.round(result[key].Total);
                    groups.push(result[key]);
                }
            }
        }
        return groups;
    }

    /* Helper functions */

    private group(r: any, a: Catch) {
        r[a.ICES] = r[a.ICES] || new ICESCatchGroup(a.ICES);
        r[a.ICES].Total += a.TotalWeight;
        r[a.ICES].Catches.push(a);
        return r;
    }

    
}